export default __webpack_public_path__ + "static/media/MCE active.ad0b694c.svg";